import { forwardRef } from "react"

import moment from "moment-timezone"

import { PolicyColumnKey } from "@common-shared/config/oneVerify/oneVerifyPoliciesColumns.config"
import { IOneVerifyCoverageCheckHistory } from "@common-shared/types/responseData/oneVerifyResponseData.types"

import { FRONT_GENERAL_CONFIG } from "@front-shared/config/general.config"
import { NIRVANA_COLORS } from "@front-shared/config/theme.config"
import { PrimaryText } from "@front-shared/elements/primaryText.element"

import { COVERAGE_CONFIG } from "../../../../config/coverage.config"
import { POLICIES_COLUMNS_CONFIG } from "../../../../config/policiesColumns.config"
import { CoverageBreakdownBadgeElement } from "../../../../elements/coverageBadges/coverageBreakdownBadge.element"
import { ExportReportHelper } from "../../../../helpers/exportReport.helper"
import { useAppDispatch } from "../../../../store/appDispatch.hook"
import { policiesSetSelectedItem } from "../../../../store/slices/policies.slice"

export const HistoryItemCardComponent = forwardRef<
    HTMLDivElement,
    IHistoryItemCardComponentProps
>((props, ref) => {
    const dispatch = useAppDispatch()

    const onView = () => {
        // Set selected item in state
        dispatch(policiesSetSelectedItem(props.item))
    }

    return (
        <div
            ref={ref}
            className={`
                ${props.className || ""}
                px-[8px] py-[12px] flex items-center transition-colors duration-200
                ${props.isSelected ? "bg-brand-offWhite" : "hover:bg-brand-warmLight"}
            `}
        >
            <div className="h-[1px] bg-brand-warmShadow flex-1" />

            <div className="flex items-center flex-col max-w-2/3 mx-[8px]">
                <CoverageBreakdownBadgeElement
                    label={
                        ExportReportHelper.getMappedColumnValue(
                            props.item,
                            POLICIES_COLUMNS_CONFIG.columnsConfig[
                                PolicyColumnKey.IDENTIFIED_PAYER
                            ],
                            COVERAGE_CONFIG.defaultFallbackCoverageDataValueUnknown,
                        ) ||
                        COVERAGE_CONFIG.defaultFallbackCoverageDataValueUnknown
                    }
                    labelTypography="captionSemibold"
                    isActive
                    wrapText={true}
                />

                <div className="flex items-center flex-col mt-[4px] gap-[4px]">
                    <div className="flex items-center gap-[12px]">
                        <PrimaryText typography="captionSemibold">
                            {!props.index
                                ? "Most Recent Check"
                                : `Previous Check ${props.index}`}
                        </PrimaryText>

                        <button
                            type="button"
                            disabled={props.isSelected}
                            className="disabled:opacity-50 disabled:cursor-not-allowed"
                            onClick={onView}
                        >
                            <PrimaryText
                                typography="captionSemibold"
                                color={NIRVANA_COLORS.brand.vibrantPurple}
                            >
                                View
                            </PrimaryText>
                        </button>
                    </div>

                    <PrimaryText typography="caption">
                        {moment(props.item.coverageResult.createdAt).format(
                            FRONT_GENERAL_CONFIG.defaultMomentDateTimeFormatReadable,
                        )}
                    </PrimaryText>
                </div>
            </div>

            <div className="h-[1px] bg-brand-warmShadow flex-1" />
        </div>
    )
})

HistoryItemCardComponent.displayName = "HistoryItemCardComponent"

interface IHistoryItemCardComponentProps {
    className?: string
    item: IOneVerifyCoverageCheckHistory
    index: number
    isSelected: boolean
}
